import { createUseStyles } from "react-jss";

export default createUseStyles({
    choiceTextHighlighter: {
        composes: "choice",
        borderRadius: ({ theme }) =>
            Math.min(theme.ChoiceListBackgroundBorderRadius, theme.ChoiceHeight / 2),
        boxSizing: "border-box",
        cursor: "pointer",
        display: ({ hasOpenEnd, openEndSize }) =>
            hasOpenEnd && openEndSize === "Full" ? "block" : "flex",
        flexWrap: "wrap",
        overflow: "hidden",
        textAlign: ({ theme }) => (theme.DisplayChoiceIcon === "right" ? "right" : ""),
        transition: "background 200ms, box-shadow 200ms, outline-color 200ms",
        userSelect: "none",
        outline: "2px solid transparent",
        "& .radio__icon, & .check-box__icon": {
            display: ({ theme }) => (theme.DisplayChoiceIcon === "none" ? "none" : ""),
        },
        fontFamily: "Open Sans",
        fontWeight: "normal",
    },
    choiceHeader: {
        composes: "choice__header",
        fontWeight: 400,
        margin: ({ theme }) => [[theme.ChoiceSpacing, 0]],
    },
    choiceTextTextHighlighter: {
        composes: "choice__text__highlighter",
        fontWeight: "normal",
        FontFace: "openSans",
    },
    choiceContainer: {
        composes: "choice__container",
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        minWidth: 125,
        flexDirection: ({ theme }) => (theme.DisplayChoiceIcon === "right" ? "row-reverse" : "row"),
        margin: [[8, 8, 8, 0]],
    },
    choiceSelectedTextHighlighter: {
        composes: "choice--selected",
    },
    choiceHoverTextHighlighter: {
        composes: "choice--hover",
    },
    choiceActiveTextHighlighter: {
        composes: "choice--active",
    },
    spacer: {
        width: 20,
    },
});
